export default __webpack_public_path__ + "static/media/success_light.63ff9df7.png";